import layout from '@/views/layout/layout.vue'
const adminList = r => require.ensure([], () => r(require('@/views/system/admin/list.vue')), 'group-system-admin')
const chanegPassword = r => require.ensure([], () => r(require('@/views/system/admin/changePassword.vue')), 'group-system-admin-changePassword')

const systemAdmin = [
  {
    path: '/system/admin',
    name: 'system-admin',
    component: layout,
    redirect: '/system/admin/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: adminList,
        name: 'system-admin-list',
        meta: {
          displayName: '管理员管理',
          requireAuth: true
        }
      },
      {
        path: 'changepassword',
        component: chanegPassword,
        name: 'system-admin-changePassword',
        meta: {
          displayName: '修改密码',
          requireAuth: true
        }
      }
    ]
  }
]

export default systemAdmin



// WEBPACK FOOTER //
// ./src/router/system/admin.js